import * as api from '../api';

const defaultPage = 1;
const defaultPerPage = 5;
const dataUrl = '/1.0/athlete/feed';

export const uploadPhoto = async file =>
    await api.fileUpload(
        '/1.0/utility/files?check=fileUploadGainz&type=feed',
        file
    );

export const getFeedCard = async feedItemId => {
    const url = `${dataUrl}/feedCard/${feedItemId}`;
    return await api.get(url);
};

export const getFeedCardUsingProgramWorkoutIdAndTeamId = async (
    programWorkoutId,
    teamId
) =>
    await api.get(
        `${dataUrl}/feedCardByPWIdTeamId/${programWorkoutId}/${teamId}`
    );

export const getAllFeeds = async (page, perPage) => {
    if (page) return await api.get(`${dataUrl}/${page}/perPage/${perPage}`);
    return await api.get(`${dataUrl}/`);
};

export const getFeed = async (feedId, page, perPage) => {
    let url = `${dataUrl}/${feedId}`;
    if (page) {
        if (!perPage) perPage = 5;
        url += `?page=${page}&perPage=${perPage}`;
    }
    return await api.get(url);
};

export const anchor = async (feedId, feedItemId, anchor) => {
    let url = `${dataUrl}/${feedId}/feedItem/${feedItemId}`;
    url = anchor ? `${url}/anchor` : `${url}/unanchor`;
    return await api.post(url);
};

export const createFeedItem = async (feedId, newFeedItem) =>
    await api.post(`${dataUrl}/${feedId}`, newFeedItem);

export const createFeedItemUsingTeamId = async (teamId, newFeedItem) =>
    await api.post(`${dataUrl}/createWithTeamId/${teamId}`, newFeedItem);

export const deleteFeedItem = async (feedId, feedItemId) =>
    await api.del(`${dataUrl}/${feedId}/feedItem/${feedItemId}`);

export const getFeedCardUsingTeamIdSwsId = async (teamId, swsId) => {
    const url = `${dataUrl}/team/${teamId}/swsId/${swsId}`;
    return await api.get(url);
};

export const getFeedByAthlete = async (athleteId, page, perPage) => {
    let url = `/2.0/coach/athlete/feed/${athleteId}`;
    const p = page || defaultPage;
    const pp = perPage || defaultPerPage;

    url += `?page=${p}&perPage=${pp}`;

    return await api.get(url);
};

export const getFeedByTeam = async (teamId, page, perPage) => {
    let url = `${dataUrl}/team/${teamId}`;
    const p = page || defaultPage;
    const pp = perPage || defaultPerPage;

    url += `?page=${p}&perPage=${pp}`;

    return await api.get(url);
};

export const getFeedItem = async feedItemId => {
    const url = `${dataUrl}/feedCard/${feedItemId}`;
    return await api.get(url);
};

export const getLikes = async (feedId, feedItemId) => {
    const url = `${dataUrl}/${feedId}/feedItem/${feedItemId}/likes`;
    return await api.get(url);
};

export const like = async (feedId, feedItemId, like) => {
    let url = `${dataUrl}/${feedId}/feedItem/${feedItemId}`;
    url = like ? `${url}/like` : `${url}/unlike`;
    return await api.post(url);
};



// WEBPACK FOOTER //
// ./src/api/service/feedService.js